import React from "react";
import { Col, Row } from "react-bootstrap";
import SecurityUtils from "../../../../utils/SecurityUtils";
import ClassificationSelectionInput from "./Input";
import ClassificationSelectionOutput from "./Output";

const ClassificationSelection = props => {
  return (
    <Row>
      {!props.readOnly
        ? SecurityUtils.renderElementByPermissions(
            <Col>
              <ClassificationSelectionInput
                messageHandler={props.messageHandler}
                classificationsFilter={props.classificationsFilter}
                setSelectedClassifications={props.setSelectedClassifications}
                defaultClassifications={props.defaultClassifications}
                reset={props.reset}
                reseted={props.reseted}
              />
            </Col>,
            props.processes,
            props.partyId
          )
        : null}
      <Col>
        <ClassificationSelectionOutput
          messageHandler={props.messageHandler}
          selectedClassifications={props.selectedClassifications}
        />
      </Col>
    </Row>
  );
};

export default ClassificationSelection;
